export const Bathub = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.527 9.12H11.474C10.791 9.12 10.309 8.451 10.525 7.804V7.804C10.86 6.798 11.801 6.12 12.861 6.12H13.139C14.199 6.12 15.14 6.798 15.475 7.804V7.804C15.691 8.451 15.209 9.12 14.527 9.12V9.12Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.99302 13.2629H4.00002C3.38602 13.2629 2.91702 13.8109 3.01202 14.4169L3.35602 16.6169C3.66002 18.5649 5.33702 19.9999 7.30802 19.9999H16.692C18.663 19.9999 20.34 18.5649 20.644 16.6179L20.988 14.4179C21.083 13.8119 20.614 13.2639 20 13.2639H12.263"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13 6.12V6C13 4.343 14.343 3 16 3V3C17.657 3 19 4.343 19 6V13.263"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.158 17.263H9.105C7.943 17.263 7 16.321 7 15.158V13.153C7 12.516 7.516 12 8.153 12H11.11C11.747 12 12.263 12.516 12.263 13.153V15.158C12.263 16.321 11.321 17.263 10.158 17.263Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6.04 19.8L5 21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 21L17.96 19.8"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
      <div>Bathub</div>
    </div>
  );
};

export const HairDryer = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 10.373V5.98498C21 5.23398 20.444 4.59898 19.7 4.49798L8.921 3.04798C5.787 2.62598 3 5.06298 3 8.22498V8.22498C3 11.405 5.817 13.847 8.965 13.396L19.713 11.857C20.451 11.752 21 11.119 21 10.373Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.84241 6.93651C10.5258 7.61993 10.5258 8.72797 9.84241 9.41138C9.159 10.0948 8.05095 10.0948 7.36754 9.41138C6.68413 8.72797 6.68413 7.61992 7.36754 6.93651C8.05096 6.2531 9.159 6.2531 9.84241 6.93651"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.75 4.31006V12.0301"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M7.00201 13.299C7.24901 15.03 7.58301 17.363 7.81701 19.006C7.98101 20.152 8.96201 21 10.12 21V21C11.535 21 12.623 19.75 12.423 18.349C12.176 16.617 11.919 14.82 11.66 13.011"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Hair Dryer</div>
    </div>
  );
};

export const Shower = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 8V8C9 5.239 11.239 3 14 3V3C16.761 3 19 5.239 19 8V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.416 12.748H6.58401C5.50401 12.748 4.74101 11.69 5.08301 10.665V10.665C5.61301 9.073 7.10201 8 8.78001 8H9.22001C10.897 8 12.387 9.073 12.917 10.665V10.665C13.259 11.69 12.496 12.748 11.416 12.748V12.748Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 20V21"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 17V16"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 19.65L14.45 18.82"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12.24 15.5L12.79 16.33"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.76005 15.5L5.21005 16.33"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.55002 18.82L3.00002 19.65"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Shower</div>
    </div>
  );
};

export const HotWater = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0013 2.99622H9.82711C9.29689 2.99622 8.78768 3.2073 8.41252 3.58246L7.99835 3.99663"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.501 8.99869H9.49896V6.99785C9.49896 6.44562 9.94715 5.99744 10.4994 5.99744H13.5006C14.0529 5.99744 14.501 6.44562 14.501 6.99785V8.99869Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.287 8.99866H9.71305C7.66119 8.99866 5.9975 10.6624 5.9975 12.7142V20.0032C5.9975 21.1087 6.89287 22.0041 7.99833 22.0041H16.0017C17.1071 22.0041 18.0025 21.1087 18.0025 20.0032V12.7142C18.0025 10.6624 16.3388 8.99866 14.287 8.99866Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 2.99622V5.99747"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Hot Water</div>
    </div>
  );
};

export const SoapDrop = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0013 2.99622H9.82711C9.2965 2.99633 8.78767 3.2072 8.41252 3.58246L7.99835 3.99663"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.501 8.99869H9.49896V6.99785C9.49896 6.44534 9.94686 5.99744 10.4994 5.99744H13.5006C14.0531 5.99744 14.501 6.44534 14.501 6.99785V8.99869Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.0025 12.7143C18.0025 11.7289 17.611 10.7838 16.9142 10.087C16.2174 9.39024 15.2724 8.99878 14.287 8.99878H9.71305C7.661 8.99878 5.9975 10.6623 5.9975 12.7143V19.0029C5.9975 20.108 6.8933 21.0038 7.99833 21.0038H13.0004"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 2.99622V5.99747"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M18.3186 15.9496L19.5802 17.6373C20.0603 18.2735 20.139 19.1266 19.7835 19.8399C19.428 20.5533 18.6995 21.004 17.9025 21.0037V21.0037C17.1044 21.0063 16.3737 20.5564 16.0167 19.8426C15.6597 19.1288 15.738 18.2744 16.2188 17.6373L17.4813 15.9496C17.5808 15.8189 17.7357 15.7422 17.9 15.7422C18.0642 15.7422 18.2191 15.8189 18.3186 15.9496V15.9496Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Soap Drop</div>
    </div>
  );
};

export const Heating = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 8V14"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.4142 14.5858C14.1953 15.3668 14.1953 16.6332 13.4142 17.4142C12.6332 18.1953 11.3668 18.1953 10.5858 17.4142C9.80474 16.6332 9.80474 15.3668 10.5858 14.5858C11.3668 13.8047 12.6332 13.8047 13.4142 14.5858"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M9 12.023V6C9 4.343 10.343 3 12 3C13.657 3 15 4.343 15 6V12.023C16.208 12.936 17 14.37 17 16C17 18.761 14.761 21 12 21C9.239 21 7 18.761 7 16C7 14.37 7.792 12.935 9 12.023Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Heating</div>
    </div>
  );
};

export const ToiletSeat = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15 12H4.5C3.67157 12 3 11.3284 3 10.5V10.5C3 9.67157 3.67157 9 4.5 9H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 2H20C20.5523 2 21 2.44772 21 3V11C21 11.5523 20.5523 12 20 12H15V3C15 2.44772 15.4477 2 16 2Z"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M21 11V11.8377C21 13.7262 19.7916 15.4028 18 16V20C18 20.5523 17.5523 21 17 21H9.28078C8.97284 21 8.68208 20.8581 8.49257 20.6154C8.30306 20.3727 8.23594 20.0562 8.31063 19.7575L9 17L8.88057 16.9701C6.59993 16.4 5 14.3508 5 12"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Toilet Seat</div>
    </div>
  );
};

export const BathHanger = () => {
  return (
    <div className="flex items-center gap-[10px]">
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 6V5C19 3.895 18.105 3 17 3V3C15.895 3 15 3.895 15 5V19C15 20.105 14.105 21 13 21H7C5.895 21 5 20.105 5 19V6C5 4.343 6.343 3 8 3H17"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M19 9V15C19 16.105 18.105 17 17 17H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15 9H20.5C21.328 9 22 8.328 22 7.5V7.5C22 6.672 21.328 6 20.5 6H15"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5 6H3.5C2.672 6 2 6.672 2 7.5V7.5C2 8.328 2.672 9 3.5 9H5"
          stroke="#323232"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <div>Hanger</div>
    </div>
  );
};
